var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.iconClasses,attrs:{"title":"Send us an enquiry"},on:{"click":function($event){$event.preventDefault();return _vm.redirectTo('enquiry')}}})}
var staticRenderFns = []

export { render, staticRenderFns }